/* unplugin-vue-components disabled */import script from "./Dqly.vue?vue&type=script&lang=ts&setup=true"
export * from "./Dqly.vue?vue&type=script&lang=ts&setup=true"

import "./Dqly.vue?vue&type=style&index=0&id=3ef1786e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ef1786e"]])

export default __exports__